// extracted by mini-css-extract-plugin
export default {"ScrolltoTopLink":"ScrollTop_ScrolltoTopLink__hH3U9"};